import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForRespondentTemplateRPC } from "./getPresignedDownloadUrlForRespondentTemplateRPC";

export class GetPresignedDownloadURLForRespondentTemplateRPCClientImpl extends GetPresignedDownloadURLForRespondentTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForRespondentTemplateRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForRespondentTemplateRPC.Response, GetPresignedDownloadURLForRespondentTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetPresignedDownloadURLForRespondentTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForRespondentTemplateRPC.ResponseDTO,
      GetPresignedDownloadURLForRespondentTemplateRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForRespondentTemplateRPC.Response,
      GetPresignedDownloadURLForRespondentTemplateRPC.Errors.Errors
    >(
      response,
      "respondent/GetPresignedDownloadURLForRespondentTemplate",
      GetPresignedDownloadURLForRespondentTemplateRPC.Response.fromDTO,
      GetPresignedDownloadURLForRespondentTemplateRPC.Errors.fromDTO
    );
  }
}
